module.exports = __webpack_public_path__ + "static/media/salesfeed.a26b9b2a.png";